/**
 * Supabase configuration
 */
import { appLogger } from '@annote/core/utils/debug';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  appLogger.error('Missing Supabase configuration:', {
    hasUrl: !!SUPABASE_URL,
    hasKey: !!SUPABASE_KEY,
    mode: import.meta.env.MODE,
    env: import.meta.env,
  });
  throw new Error('Missing Supabase configuration. Check your .env file.');
}
